export default "__VITE_ASSET__ee190285__"